export default "__VITE_ASSET__HN06e8Nu__"